module.exports = __webpack_public_path__ + "img/common-types.070ba4b.svg";